<div *ngFor="let client of permissions.clients" class="section">
  <h4 class="section-title">{{getClientName(client)}}</h4>
  <mat-table [dataSource]="client.organizations" class="table">
    <ng-container matColumnDef="carrier">
      <mat-header-cell *matHeaderCellDef class="mx-1 td-clientName">{{ 'profileStrangers.carrier' | transloco }}</mat-header-cell>
      <mat-cell *matCellDef="let element" class="mx-1 td-clientName">
        <div class="section-column">
          <span>{{ element.legalForm }} {{ element.fullName }}</span>
          <span><span class="text-bold">ИНН:</span> {{ element.inn }}</span>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="role">
      <mat-header-cell class="mx-1 td-roleName" *matHeaderCellDef>{{ 'profileStrangers.role' | transloco }}</mat-header-cell>
      <mat-cell *matCellDef="let element" class="mx-2 td-roleName">{{ getRoleName(element) }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions">
      <mat-header-cell class="mx-1 td-roleName" *matHeaderCellDef>{{ 'profileStrangers.actions' | transloco }}</mat-header-cell>
      <mat-cell *matCellDef="let element" class="mx-1 td-actions">
        <button *ngIf="!element.isCurrent"
                class="primary xs py-1 px-2"
                disableRipple
                data-test="stranger-permissions_btn-request-access-rights"
                (click)="onSwitchOrganizationClick(element)">
          {{ 'profileStrangers.switch' | transloco }}
        </button>
      </mat-cell>
      <mat-header-row class="mat-header-row-sticky row-min-width" *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row class="row-min-width" *matRowDef="let row; columns: displayedColumns"></mat-row>
    </ng-container>
  </mat-table>
  <div class="buttons">
    <button *ngIf="canJoinToOrganization()"
            class="primary xs py-1 px-2"
            disableRipple
            data-test="stranger-permissions_btn-request-access-rights"
            (click)="onJoinOrganizationClick(client)">
      <svg-icon key="addSmall" class="s"></svg-icon>
      {{ 'profileStrangers.requestToNewOrganization' | transloco }}
    </button>
  </div>
</div>
